import { facilityCollectionService } from '@/entities/facility-collection/api/facility-collection.api';
import { useMutation } from '@tanstack/react-query';

/**
 * 병의원·약국 공공 데이터 수집 배치 실행.
 * 배치가 끝난 시점을 알 수 없어(조회 API 없음) 목록 쿼리는 invalidate 하지 않는다.
 */
export const useRunFacilityCollectionJob = () =>
  useMutation({
    mutationFn: (baseYm?: string) => facilityCollectionService.run(baseYm),
  });
